export * from "./hatchback-icon.component";
